"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var model_actions_creators_1 = require("../../../../../store/model.actions.creators");
var styles = __importStar(require("./../../CampusHours.module.css"));
var COLLEGE = {
    CA: {
        title: "SACRAMENTO CAMPUS SPECIFICS",
        urlImage: "/img/campus-ca.png",
        content: [[
                "MONDAY - THURSDAY",
                "9AM - 8PM"
            ],
            [
                "FRIDAY",
                "9AM - 6PM"
            ],
            [
                "SATURDAY",
                "9AM - 4PM"
            ]]
    },
    NV: {
        title: "LAS VEGAS CAMPUS SPECIFICS",
        urlImage: "/img/campus-nv.png",
        content: [[
                "MONDAY - THURSDAY",
                "9AM - 8PM"
            ],
            [
                "FRIDAY",
                "9AM - 6PM"
            ]]
    },
    TX: {
        title: "DALLAS CAMPUS SPECIFICS",
        urlImage: "/img/campus-tx.png",
        content: [[
                "MONDAY - THURSDAY",
                "10AM - 7PM"
            ],
            [
                "FRIDAY - SATURDAY",
                "11AM - 4PM"
            ]]
    }
};
function mapStateToProps(_a) {
    var model = _a.model;
    return { json_data: model.json_data };
}
var mapDispatchToProps = {
    updateJsonCallback: model_actions_creators_1.updateJson
};
function InformationProvided(props) {
    var stateSelected = props.stateSelected;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("header", null,
            react_1.default.createElement("div", { className: "row " + styles.paddintTopContent },
                react_1.default.createElement("div", { className: "col-md-12 " + styles.textCenter },
                    react_1.default.createElement("h1", { className: styles.textCustom }, COLLEGE[stateSelected].title)))),
        react_1.default.createElement("article", null,
            react_1.default.createElement("h2", { className: styles.sectionTitle }, "Employers who have hired our graduates"),
            react_1.default.createElement("div", { className: "col-md-12 " + styles.textCenter },
                react_1.default.createElement("img", { src: "" + COLLEGE[stateSelected].urlImage, alt: "" }))),
        react_1.default.createElement("article", { className: styles.fontCustom },
            react_1.default.createElement("h2", { className: styles.sectionTitle }, "Campus Hours"),
            react_1.default.createElement("div", { className: "col-md-12" },
                react_1.default.createElement("table", { className: "table table-border" },
                    react_1.default.createElement("tbody", null, COLLEGE[stateSelected].content.map(function (dayHour, i) { return (react_1.default.createElement("tr", { key: i }, dayHour.map(function (val, index) { return (react_1.default.createElement("td", { key: index, className: styles.paddingTd },
                        react_1.default.createElement("b", null, val))); }))); }))))),
        react_1.default.createElement("div", { className: styles.textCenter },
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Three Tracks-"),
                " 12 hours per week / 18 hours per week / 24 hours per week"))));
}
exports.InformationProvided = InformationProvided;
exports.AsherInformationProvided = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(InformationProvided);
//# sourceMappingURL=data:application/json;base64,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